import React, { useEffect, useState } from "react";
import {
  Accordion,
  Col,
  Form,
  FormGroup,
  Row,
} from "react-bootstrap";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";
import Loader from "../loader/Loader";
import edit from "./edit.png";
import deletee from "./delete.png";
import { SettingLayout } from "./SettingShell";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton, SecondaryButton, DangerButton } from "../../globalComponents/ui/Button";
import { SettingsModalBody, SettingsModalFooter } from "./SettingShell";
import DataTable from "../../globalComponents/ui/DataTable/DataTable";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { ROLE_ID_MAPPING } from "../../_constants/constants";
import { usePermission } from "../../hooks/usePermission";

const AccessManagement = (props) => {
  const { tab, userPermissionList } = props;
  const [canCreateRole] = usePermission("permission-management.create-management-role", "CREATE_MANAGEMENT_ROLE");
  const [canReassignUser] = usePermission("permission-management.reassign-user", "REASSIGN_USER");
  const [canRemoveUser] = usePermission("permission-management.remove-user", "REMOVE_USER");

  const [pemissionList, setPemissionList] = useState(null);
  const [showAddManagement, setShowAddManagement] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [currentRoleId, setCurrentRoleId] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedId, setSelectedId] = useState(null);
  const [managementListValue, setManagementListValue] = useState([]);
  const [filterListValue, setFilterListValue] = useState([]);
  const [updatedPermissions, setUpdatedPermissions] = useState([]);
  const [auditModule, setAuditModule] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showSkelton, setshowSkelton] = useState(false);
  const [answerAccepted, setAnswerAccepted] = useState();
  const [isError, setIsError] = useState(false);
  const [deleteAccessPopup, setDeleteAccessPopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndices, setActiveIndices] = React.useState({});
  const [currentUserPermissions, setCurrentUserPermissions] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const getRolePermissions = async (roleId) => {
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getPermissionDataBasedOnRoleId`,
      {},
      { role_id: roleId },
      "GET"
    );

    if (isSuccess) {
      return data?.data ?? []
    }

    return [];
  }

  useEffect(() => {
    const fetchPermissions = async () => {
      const permissions = await getRolePermissions(
        currentUser.roleId ?? 1
      );

      setCurrentUserPermissions(permissions);
    };

    fetchPermissions();
  }, []);

  const closeDeleteAccessPopup = () => setDeleteAccessPopup(false);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const showDeleteAccessPopup = (id) => {
    setSelectedId(id);
    setDeleteAccessPopup(true);
  };

  const handleShowAddManagement = () => {
    setMode("create");
    setShowAddManagement(true);
  };

  const handleEditRoleMasterShow = (id, inputValue) => {
    setMode("edit");
    setSelectedId(id);
    setRoleName(inputValue);
    setShowAddManagement(true);
  };

  const handleCloseAddManagement = () => {
    setMode("create");
    setIsError(false);
    setShowAddManagement(false);
  };

  const setRoleTitle = (e) => {
    const inputValue = e.target.value;
    const isDuplicate = managementListValue.some(
      (data) => data.role_name === inputValue
    );
    if (isDuplicate) {
      setIsError(true);
    } else {
      setRoleName(inputValue);
      setIsError(false);
    }
  };

  const createRoleMaster = async () => {
    const { isSuccess, data, error } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `createRoleMaster`,
      {},
      { roleName: roleName },
      "POST"
    );
    if (isSuccess) {
      roleManagementList();
      setRoleName("");
      handleCloseAddManagement();
    }
  };

  const updateRoleMaster = async (e) => {
    const { isSuccess, data, error } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `updateRoleMaster`,
      {},
      { roleName: roleName, id: selectedId },
      "POST"
    );
    if (isSuccess) {
      roleManagementList();
      setRoleName("");
      handleCloseAddManagement();
    }
  };

  const deleteRoleMaster = async () => {
    const { isSuccess, data, error } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `deleteRoleMaster`,
      {},
      { id: selectedId },
      "POST"
    );
    if (isSuccess) {
      roleManagementList();
      closeDeleteAccessPopup();
    }
  };

  const handleSearch = (searchTerm) => {
    const trimmedSearchTerm = searchTerm.trim();

    if (trimmedSearchTerm === "") {
      setFilterListValue([...managementListValue]);
    } else {
      const filteredResult = managementListValue.filter((item) =>
        item.role_name.toLowerCase().includes(trimmedSearchTerm.toLowerCase())
      );
      setFilterListValue(filteredResult);
    }
  };

  const roleManagementList = async () => {
    setshowSkelton(true);
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getMasterData`,
      {},
      {},
      "GET"
    );
    if (isSuccess) {
      setshowSkelton(false);
      setManagementListValue(data?.data?.reverse());
      setFilterListValue(data?.data);
    }
  };

  function extractPermissions(menus, map = new Map(), parentSequence = null) {
    for (const menu of menus || []) {
      const currentSequence = menu.sequence ?? parentSequence;
      for (const permission of menu.permissions || []) {
        map.set(`${currentSequence}_${permission.permissionCode}`, permission.checked);
      }

      extractPermissions(menu.sub_menu || [], map, currentSequence);
    }

    return map;
  }

  function applyPermissions(menus, rolePermissionMap, parentSequence = null) {
    console.log('menus', menus);
    return (menus || []).map((menu) => {
      const currentSequence = menu.sequence ?? parentSequence;
      return {
        ...menu,

        permissions: (menu.permissions || []).map((permission) => ({
          ...permission,

          checked: rolePermissionMap.has(`${currentSequence}_${permission.permissionCode}`)
            ? rolePermissionMap.get(`${currentSequence}_${permission.permissionCode}`)
            : false,
        })),

        sub_menu: applyPermissions(menu.sub_menu || [], rolePermissionMap, currentSequence),
      };
    });
  }

  const rolePermissionList = async (roleId) => {
    setshowSkelton(true);
    setCurrentRoleId(roleId);

    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getPermissionDataBasedOnRoleId`,
      {},
      { role_id: roleId },
      "GET"
    );

    if (isSuccess) {
      setshowSkelton(false);
      console.log('currentUserPermissions', currentUserPermissions);
      const rolePermissionMap = extractPermissions(data.data);
      console.log('rolePermissionMap', rolePermissionMap);
      const updatedPermissions = applyPermissions(currentUserPermissions, rolePermissionMap);
      console.log('updatedPermissions', updatedPermissions);
      setPemissionList(updatedPermissions);
      setAnswerAccepted(data?.answerAccepted);
    }
  };

  const updatePermissionToRole = async () => {
    const { isSuccess, data, error } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `updatePermissionToRole`,
      {},
      { updatedPermissions: updatedPermissions, roleId: currentRoleId },
      "POST"
    );
    if (isSuccess) {
      const userRoleId = currentUser?.roleId || currentUser?.role_id;
      if (Number(currentRoleId) === Number(userRoleId)) {
        const userId = Number(localStorage.getItem("user_temp_id"));
        const roleParam = (localStorage.getItem("role") || "company").toUpperCase();
        const roleIdMappingVal = ROLE_ID_MAPPING ? (ROLE_ID_MAPPING[roleParam] || 1) : 1;
        const profileRes = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}getProfileData?userId=${userId}&role_id=${roleIdMappingVal}`
        );
        if (profileRes.isSuccess && profileRes.data?.menu) {
          localStorage.setItem("menu", JSON.stringify(profileRes.data.menu));
        }
      }
      rolePermissionList(currentRoleId);
    }
  };

  const MenuItem = ({
    index,
    item,
    handleCheckboxChange,
    handleAccordionClick,
    activeIndices,
    parentKey = "" // Pass an identifier for nested items
  }) => {
    const handleAllCheckboxChange = () => {
      // Determine if all checkboxes should be checked or unchecked
      // If all are currently checked, we'll uncheck them all; otherwise, check them all
      const allChecked = !item.permissions.every((permission) => permission.checked);

      // Extract all permission codes in this menu item
      const codes = item.permissions.map((permission) => permission.permissionCode);

      // Perform an atomic update of all permissions in one single call
      handleCheckboxChange(item.sequence, item, codes, parentKey, allChecked);
    };

    // Create a unique key for each accordion level (outer or inner)
    const accordionKey = parentKey ? `${parentKey}-${index}` : `${index}`;

    return (
      <div className="my-2">
        <Accordion>
          <Accordion.Item eventKey={accordionKey}>
            <h2 className="accordion-header" id={`heading${accordionKey}`}>
              <button
                className="accordion-button d-flex justify-content-between align-items-center"
                type="button"
                style={{
                  backgroundColor: "#BFD7E0",
                  color: "black",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "1rem 1rem",
                }}
                onClick={() => handleAccordionClick(accordionKey)}
                aria-expanded={!!activeIndices[accordionKey]} // Check against activeIndices object
                aria-controls={`collapse${accordionKey}`}
              >
                <div style={{ flex: "0 0 80%" }}>
                  <span style={{ color: "black", marginBottom: "10px" }}>
                    {index + 1}. {item?.caption}
                  </span>
                </div>
                <div
                  style={{
                    flex: "0 0 10%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="btn btn-sm btn-outline-secondary"
                    style={{
                      fontWeight: "bold",
                      height: "30px",
                      width: "30px",
                      border: "1.5px solid",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderColor: "grey",
                    }}
                  >
                    {!!activeIndices[accordionKey] ? "-" : "+"}
                  </div>
                </div>
              </button>
            </h2>
            <div
              id={`collapse${accordionKey}`}
              className={`accordion-collapse collapse ${activeIndices[accordionKey] ? "show" : ""}`}
              aria-labelledby={`heading${accordionKey}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ background: "#E3EBED" }}>
                <Row style={{ gap: "21px", width: "100%" }}>
                  {!showSkelton ? (
                    <>
                      {item.permissions.length > 0 && !item.sub_menu.length && (
                        <Col md={4} className="permission-checkbox" style={{ padding: "10px 10px", background: "#E3EBED", border: "1px solid black" }}>
                          <Form.Check
                            type="checkbox"
                            id={`checkAll${item.sequence}`}
                            label="All"
                            checked={item.permissions.length > 0 && item.permissions.every((permission) => permission.checked)}
                            onChange={handleAllCheckboxChange}
                          />
                        </Col>
                      )}
                      {item.sub_menu.length > 0
                        ? item.sub_menu.map((subItem, subIndex) => (
                          <MenuItem
                            key={subItem.sequence}
                            index={subIndex}
                            item={subItem}
                            handleCheckboxChange={handleCheckboxChange}
                            handleAccordionClick={handleAccordionClick}
                            activeIndices={activeIndices}
                            parentKey={accordionKey} // Pass current accordionKey as parentKey
                          />
                        ))
                        : item.permissions.map((permission, permissionIndex) => (
                          <Col key={permissionIndex} md={4} className="permission-checkbox" style={{ padding: "10px 10px", background: "#E3EBED", border: "1px solid black" }}>
                            <Form.Check
                              type="checkbox"
                              id={`check-${item.sequence}-${permission.permissionCode}`}
                              label={permission.view}
                              checked={permission.checked}
                              onClick={(e) => e.stopPropagation()} // Prevent accordion toggle
                              onChange={(e) => {
                                e.preventDefault(); // Prevent default behavior
                                handleCheckboxChange(item.sequence, item, permission.permissionCode, parentKey);
                              }}
                            />
                          </Col>
                        ))}
                    </>
                  ) : (
                    <Loader />
                  )}
                </Row>
              </div>
            </div>
          </Accordion.Item>
        </Accordion>
      </div>
    );
  };

  const Menu = ({ jsonData }) => {
    const updatedPermission = (menuItem, code, forceChecked = null) => {
      if (menuItem && menuItem.permissions) {
        const codes = Array.isArray(code) ? code : [code];
        const updatedPermissions = menuItem.permissions.map((permission) => {
          if (codes.includes(permission.permissionCode)) {
            return {
              ...permission,
              checked: forceChecked !== null ? forceChecked : !permission.checked,
            };
          }
          return permission;
        });

        const updatedParentMenuItem = {
          ...menuItem,
          permissions: updatedPermissions,
        };
        return updatedParentMenuItem;
      }
      return menuItem;
    };

    const handleCheckboxChange = (
      menuSequence,
      menuItem,
      code,
      parentKey,
      forceChecked = null
    ) => {
      let tmpUpdated;
      let targetSequence;

      // Handle parent-child relationship
      if (parentKey) {
        // Find the parent menu item based on parentKey
        const parentMenuItem = findParentMenuItem(jsonData, parentKey);

        if (parentMenuItem) {
          targetSequence = parentMenuItem.sequence;
          // Update the corresponding sub-menu item
          const updatedParentMenuItem = {
            ...parentMenuItem,
            sub_menu: parentMenuItem.sub_menu.map((subItem) => {
              if (subItem.sequence === menuSequence) {
                return updatedPermission(subItem, code, forceChecked);
              }
              return subItem;
            })
          };
          tmpUpdated = updatedParentMenuItem;

          // Update the rendering list state so the UI reflects it instantly
          setPemissionList((prevList) =>
            prevList.map((topLevelItem) => {
              if (topLevelItem.sequence === parentMenuItem.sequence) {
                return updatedParentMenuItem;
              }
              return topLevelItem;
            })
          );
        }
      } else {
        targetSequence = menuItem.sequence;
        // Direct update for top-level menu items
        tmpUpdated = updatedPermission(menuItem, code, forceChecked);

        // Update the rendering list state so the UI reflects it instantly
        setPemissionList((prevList) =>
          prevList.map((topLevelItem) => {
            if (topLevelItem.sequence === menuItem.sequence) {
              return tmpUpdated;
            }
            return topLevelItem;
          })
        );
      }

      if (tmpUpdated && targetSequence) {
        // Update the state with the changes using targetSequence
        setUpdatedPermissions((prevData) => {
          const updatedData = [...prevData];
          const existingPermissionIndex = updatedData.findIndex(
            (item) => item.sequenceId === targetSequence
          );

          if (existingPermissionIndex !== -1) {
            // If targetSequence already exists, update the existing object
            updatedData[existingPermissionIndex] = {
              sequenceId: targetSequence,
              permission: tmpUpdated,
            };
          } else {
            // If targetSequence doesn't exist, add a new object to the array
            updatedData.push({
              sequenceId: targetSequence,
              permission: tmpUpdated,
            });
          }

          return updatedData;
        });
      }
    };

    // Helper function to find a parent menu item based on the parentKey
    const findParentMenuItem = (menuItems, parentKey) => {
      // Parse the parentKey to get the index
      const index = parseInt(parentKey.split('-')[0]);
      if (!isNaN(index) && index >= 0 && index < menuItems.length) {
        return menuItems[index];
      }
      return null;
    };

    const handleAccordionClick = (key) => {
      setActiveIndices((prevIndices) => {
        // Toggle just the clicked one
        return {
          ...prevIndices,
          [key]: !prevIndices[key]
        };
      });
    };

    return (
      <div>
        {!showSkelton ? (
          jsonData.map((menuItem, index) => (
            <MenuItem
              index={index}
              key={menuItem.sequence}
              item={menuItem}
              handleCheckboxChange={handleCheckboxChange}
              handleAccordionClick={handleAccordionClick}
              activeIndices={activeIndices} // Pass the activeIndices object
            />
          ))
        ) : (
          <Loader />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (filterListValue && filterListValue.length > 0) {
      const initialSelectedItem = filterListValue[0];
      setSelectedItem(initialSelectedItem?.id);
      rolePermissionList(initialSelectedItem?.id);
      setAuditModule(initialSelectedItem.system_created);
    }
  }, [filterListValue]);

  useEffect(() => {
    roleManagementList();
  }, [tab]);

  const [show, setShow] = useState(false);

  // Function to toggle the modal visibility
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <SettingLayout
      title="Permission Management"
      subtitle={`${filterListValue.length} role${filterListValue.length !== 1 ? "s" : ""} configured`}
      $wide
      rightContent={
        canCreateRole && (
          <PrimaryButton onClick={handleShowAddManagement}>
            <i className="fas fa-plus" style={{ marginRight: 6 }} />
            Add Role
          </PrimaryButton>
        )
      }
    >
      {showSkelton ? (
        <div style={{ padding: 40 }}><Loader /></div>
      ) : (
        <DataTable
          title="Management Roles"
          data={filterListValue.map((item, idx) => ({ ...item, _id: item.id, _idx: idx + 1 }))}
          columns={[
            { key: "_idx", label: "#", width: "60px" },
            { key: "role_name", label: "Role Name", sortable: true },
          ]}
          searchable
          searchFields={["role_name"]}
          emptyMessage="No roles found"
          extraActions={(row) => [
            {
              label: "Permissions",
              icon: "fas fa-key",
              variant: "view",
              onClick: () => {
                rolePermissionList(row.id);
                setAuditModule(row.system_created);
                setSelectedItem(row.id);
                handleShow();
              },
            },
            ...(canReassignUser && row.is_deletable
              ? [{
                label: "Edit Role",
                icon: "fas fa-edit",
                variant: "edit",
                onClick: () => handleEditRoleMasterShow(row.id, row.role_name),
              }]
              : []),
            ...(canRemoveUser && row.is_deletable
              ? [{
                label: "Delete Role",
                icon: "fas fa-trash",
                variant: "del",
                onClick: () => showDeleteAccessPopup(row.id),
              }]
              : []),
          ]}
        />
      )}

      {/* Permissions Modal */}
      <Modal show={show} onClose={handleClose} maxWidth={780}>
        <ModalHeader
          icon="fas fa-key"
          title="Permissions Group"
          onClose={handleClose}
        />
        <SettingsModalBody>
          <div className="access__group__section">
            <div className="access__section">
              {pemissionList && <Menu jsonData={pemissionList} />}
            </div>
            {answerAccepted && (
              <div className="access__section">
                <p>Do you want to audit?</p>
                <FormGroup>
                  <Form.Check type="checkbox" id="checkYes" label="Yes" checked={answerAccepted === "YES"} readOnly />
                  <Form.Check type="checkbox" id="checkNo" label="No" checked={answerAccepted === "NO"} readOnly />
                </FormGroup>
              </div>
            )}
          </div>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={handleClose}>Close</SecondaryButton>
          <PrimaryButton onClick={updatePermissionToRole}>Assign Permission</PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      {/* Add / Edit Role Modal */}
      <Modal show={showAddManagement} onClose={handleCloseAddManagement} maxWidth={400}>
        <ModalHeader
          icon={mode === "create" ? "fas fa-plus" : "fas fa-edit"}
          title={mode === "create" ? "Create Role" : "Update Role"}
          onClose={handleCloseAddManagement}
        />
        <SettingsModalBody>
          <input
            className="form-control"
            type="text"
            defaultValue={mode === "create" ? "" : roleName}
            placeholder="Enter Role Name"
            onChange={(e) => setRoleTitle(e)}
          />
          {isError && (
            <span style={{ color: "red", fontSize: 12 }}>This Role Already Exists.</span>
          )}
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={handleCloseAddManagement}>Cancel</SecondaryButton>
          <PrimaryButton
            disabled={isError || roleName === ""}
            onClick={mode === "create" ? createRoleMaster : updateRoleMaster}
          >
            {mode === "create" ? "Create Role" : "Update Role"}
          </PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={deleteAccessPopup} onClose={closeDeleteAccessPopup} maxWidth={400}>
        <ModalHeader icon="fas fa-trash" title="Delete Role" onClose={closeDeleteAccessPopup} />
        <SettingsModalBody>
          <p style={{ margin: 0, fontSize: 13, color: "#475569" }}>
            Are you sure you want to delete this role?
          </p>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={closeDeleteAccessPopup}>Cancel</SecondaryButton>
          <DangerButton onClick={deleteRoleMaster}>Delete</DangerButton>
        </SettingsModalFooter>
      </Modal>

    </SettingLayout>
  );
};

export default AccessManagement;